import React from "react";
import "./Experience.css";

const experiences = [
  {
    id: 1,
    company: "Catalyst",
    position: "Lead Admin",
    type: "Full-time",
    duration: "Aug 2024 - Present · 1 yr 2 mos",
    location: "Remote",
    description: "Leading administrative operations and community management for Catalyst platform, a community-driven platform for emerging talent.",
    skills: ["Community Management", "Leadership", "Project Management"],
    logo: "assets/experience/catalyst.webp"
  },
  {
    id: 2,
    company: "Netlabs Australia Pty Ltd",
    position: "Software Engineer",
    type: "Full-time",
    duration: "Mar 2025 - Aug 2025 · 6 mos",
    location: "Vizianagaram, Andhra Pradesh, India · Remote",
    description: "Implementing applications powered by AI and latest Full stack technologies, with end to end workflows",
    skills: ["Software Infrastructure", "Database Administration", "AI Integration", "Full-Stack Development"],
    logo: "assets/experience/netlabs.webp"
  },
  {
    id: 3,
    company: "Netlabs Australia Pty Ltd",
    position: "Software Engineer",
    type: "Internship",
    duration: "Jul 2024 - Mar 2025 · 9 mos",
    location: "Vizianagaram, Andhra Pradesh, India · Remote",
    description: "Implementation of frontend, backend and system design requirements of internal projects",
    skills: ["Full-Stack Development", "System Design", "Frontend Development", "Backend Development"],
    logo: "assets/experience/netlabs.webp"
  }
];

const Experience = () => {
  return (
    <section className="experience-section" id="experience">
      <h2 className="section-title">Experience</h2>
      <div className="experience-container">
        {experiences.map((exp, index) => (
          <div className="experience-card" key={exp.id}>
            <div className="experience-header">
              <div className="company-logo">
                <img src={exp.logo} alt={`${exp.company} logo`} />
              </div>
              <div className="experience-info">
                <h3 className="position-title">{exp.position}</h3>
                <h4 className="company-name">{exp.company}</h4>
                <div className="job-details">
                  <span className="job-type">{exp.type}</span>
                  <span className="duration">{exp.duration}</span>
                </div>
                <p className="location">{exp.location}</p>
              </div>
            </div>
            <div className="experience-content">
              <p className="description">{exp.description}</p>
              <div className="skills-container">
                {exp.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
